/**
 * Radix portals default to `document.body`. In the storefront editor, that lets
 * inspector dropdowns paint over the preview iframe. `#editor-root` scopes overlays
 * to the editor shell; in the mobile preview document there is no `#editor-root`,
 * so we fall back to that document's `body` (isolated from the parent page).
 */
export function getEditorPortalContainer(): HTMLElement {
  if (typeof document === 'undefined') {
    throw new Error('getEditorPortalContainer: document is not available')
  }
  return document.getElementById('editor-root') ?? document.body
}

export function getIframePortalContainer(iframe?: HTMLIFrameElement | null): HTMLElement {
  if (iframe?.contentDocument?.body) return iframe.contentDocument.body
  if (typeof document !== 'undefined') return document.body
  throw new Error('getIframePortalContainer: no document')
}
